/**
 * approvalLimits.js
 *
 * Single shared source for the commercial approval-limit threshold.
 * Confirmed by direct code inspection that this value was previously
 * duplicated in two places with identical values (a real Duplication
 * risk, not yet a live bug):
 *   - PurchaseOrders.jsx's APPROVAL_LIMITS (Material PO path)
 *   - PurchaseOrders.jsx's REP_APPROVAL_LIMITS (Equipment PO path)
 *
 * Per the approved decision, this file is now the ONLY place the
 * threshold is defined. PurchaseOrders.jsx (both paths), and
 * Subcontracts.jsx's contract-level approval logic (extended in this
 * same change to use the same threshold) all import from here.
 */

export const APPROVAL_LIMITS = { cost_control: 1000000, director: Infinity }

/**
 * Determines which role's approval is REQUIRED to be the FINAL one for
 * a given amount — 'cost_control' if at or under the threshold,
 * 'director' otherwise. Same semantics as the pre-existing
 * getRequiredApprover()/repGetRequiredApprover() functions this
 * replaces (both computed identically, just duplicated).
 *
 * @param {number} amount
 * @returns {'cost_control'|'director'}
 */
export function getRequiredApprover(amount) {
  return (amount || 0) <= APPROVAL_LIMITS.cost_control ? 'cost_control' : 'director'
}
